// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Interpreting Signals – loader and fade-in (no external libs) */

@keyframes interpretingSignalsFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes interpretingSignalsSpin {
  to {
    transform: rotate(360deg);
  }
}

.interpreting-signals-fade-in {
  animation: interpretingSignalsFadeIn 0.6s ease-out forwards;
}

.interpreting-signals-spinner {
  animation: interpretingSignalsSpin 0.9s linear infinite;
}

/* Staggered content reveal (after loader): fade-in + slight upward motion, once on load */
@keyframes interpretingSignalsFadeInUp {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.interpreting-signals-content > * {
  opacity: 0;
}

.interpreting-signals-content-revealed > * {
  animation: interpretingSignalsFadeInUp 0.85s ease-out forwards;
}

.interpreting-signals-content-revealed > *:nth-child(1) {
  animation-delay: 0.25s;
}
.interpreting-signals-content-revealed > *:nth-child(2) {
  animation-delay: 0.32s;
}
.interpreting-signals-content-revealed > *:nth-child(3) {
  animation-delay: 0.39s;
}
.interpreting-signals-content-revealed > *:nth-child(4) {
  animation-delay: 0.46s;
}
.interpreting-signals-content-revealed > *:nth-child(5) {
  animation-delay: 0.49s;
}
`, "",{"version":3,"sources":["webpack://./src/styles/InterpretingSignals.animations.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,uDAAuD;AACzD;;AAEA,0FAA0F;AAC1F;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB","sourcesContent":["/* Interpreting Signals – loader and fade-in (no external libs) */\n\n@keyframes interpretingSignalsFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes interpretingSignalsSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.interpreting-signals-fade-in {\n  animation: interpretingSignalsFadeIn 0.6s ease-out forwards;\n}\n\n.interpreting-signals-spinner {\n  animation: interpretingSignalsSpin 0.9s linear infinite;\n}\n\n/* Staggered content reveal (after loader): fade-in + slight upward motion, once on load */\n@keyframes interpretingSignalsFadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.interpreting-signals-content > * {\n  opacity: 0;\n}\n\n.interpreting-signals-content-revealed > * {\n  animation: interpretingSignalsFadeInUp 0.85s ease-out forwards;\n}\n\n.interpreting-signals-content-revealed > *:nth-child(1) {\n  animation-delay: 0.25s;\n}\n.interpreting-signals-content-revealed > *:nth-child(2) {\n  animation-delay: 0.32s;\n}\n.interpreting-signals-content-revealed > *:nth-child(3) {\n  animation-delay: 0.39s;\n}\n.interpreting-signals-content-revealed > *:nth-child(4) {\n  animation-delay: 0.46s;\n}\n.interpreting-signals-content-revealed > *:nth-child(5) {\n  animation-delay: 0.49s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
